<template>
    <div id="workOrderManageRmk">
        <i class="el-icon-refresh" style="position: absolute;right:20px;top:15px;font-size: 25px;cursor: pointer;" @click="refresh()"></i>
        <el-col class="searthPart" style="width: 100%;">
            <ul class="order-status">
                <li class="clearfix orderListsLi" @click="clickLi(1)" :class="{highLight:activeIndex == 1}">
                    <span>待处理</span>
                    <span>{{orderCount.count1}}</span>
                </li>
                <li class="clearfix orderListsLi" @click="clickLi(2)" :class="{highLight:activeIndex == 2}">
                    <span>已挂起</span>
                    <span>{{orderCount.count2}}</span>
                </li>
                <li class="clearfix orderListsLi" @click="clickLi(3)" :class="{highLight:activeIndex ==3}">
                    <span>已处理</span>
                   <!--  <span>{{orderCount.count3}}</span> -->
                </li>
                <li class="clearfix orderListsLi" @click="clickLi(4)" :class="{highLight:activeIndex == 4}">
                    <span>无法确认</span>
                    <span>{{orderCount.count4}}</span>
                </li>
                <!-- <li class="clearfix orderListsLi" @click="clickLi(6)" :class="{highLight:activeIndex == 6}">
                    <span>修后待处理</span>
                    <span>{{orderCount.count6}}</span>
                </li> -->

                   <li class="clearfix orderListsLi" @click="clickLi(11)" :class="{highLight:activeIndex == 11}">
                    <span>已完成</span>
                    <!-- <span>{{orderCount.count11}}</span> -->
                </li>


                <li class="clearfix orderListsLi" @click="clickLi(5)" :class="{highLight:activeIndex == 5}">
                    <span>已取消</span>
                    <!-- <span>{{orderCount.count5}}</span> -->
                </li>
                <li class="clearfix orderListsLi" @click="clickLi(0)" :class="{highLight:activeIndex == 0}">
                    <span>全部订单</span>
                    <!-- <span>{{orderNot.count1}}</span> -->
                </li>
                <li class="clearfix orderListsLi" style="border:none">
                    <el-button v-if="basicsAuth.createOrder" size="medium" type="success" @click="createOrder()">新建工单</el-button>
                </li>
            </ul>
            <el-form class="form-wrapper" ref="searchForm" :model="searchForm" label-width="100px" :label-position="labelPosition">         
                <div class="form-content">
                    <el-input clearable class="text-input" v-model.trim="searchForm.orderNo" placeholder="工单编号" style="margin-bottom: 10px;"></el-input> 
                    <el-input clearable class="text-input" v-model.trim="searchForm.customerName" placeholder="客户名称" style="margin-bottom: 10px;"></el-input>                    
                    <el-input clearable class="text-input" v-model.trim="searchForm.telephoneNo" placeholder="客户手机号" style="margin-bottom: 10px;"></el-input>
                    <el-input clearable class="text-input" v-model.trim="searchForm.address" placeholder="客户地址" style="margin-bottom: 10px;"></el-input>
                    <el-date-picker
                        style="width: 245px;margin-bottom:10px"
                        v-model="valueTime1"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="daterange"
                        range-separator="-"
                        :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="下单开始"
                        end-placeholder="下单结束">
                    </el-date-picker>
                    <el-date-picker
                        style="width: 245px;margin-bottom:10px"
                        v-model="valueTime2"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="daterange"
                        range-separator="-"
                        :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="预约开始"
                        end-placeholder="预约结束">
                    </el-date-picker>
                     <el-select clearable filterable v-model.trim="searchForm.handleRmk" placeholder="处理人" style="width:125px;margin-bottom: 10px;margin-right: 10px">
                        <el-option v-for="item,index in handleList" 
                            :key="index" 
                            :label="item.staffName" 
                            :value="item.userId">
                        </el-option>
                    </el-select>
                    <el-select clearable filterable @change="changeEnginner" :filter-method="PinyinMatch" v-model="searchForm.engineerId" placeholder="工程师" style="width:125px;margin-bottom: 10px;margin-right: 10px">
                        <el-option v-for="item,index in engineersList" :key="index" :label="item.name" :value="item.id">{{item.name}}</el-option>
                    </el-select>
                    <el-select filterable clearable v-model="searchForm.brandId" placeholder="品牌" @change="choseBrand" style="width:125px;margin-bottom:10px;margin-right: 10px">
                        <el-option 
                            v-for="item,index in brandList" 
                            :key="index" :label="item.brandName" 
                            :value="item.brandId">
                        </el-option>
                    </el-select>
                    <el-select v-if="categoryList.length > 0" filterable clearable v-model="searchForm.categoryId"  placeholder="品类" style="width:125px;margin-bottom:10px;margin-right: 10px" @change="choseCategory">
                        <el-option 
                            v-for="item,index in categoryList" 
                            :key="index" 
                            :label="item.categoryName" 
                            :value="item.categoryId">
                        </el-option>
                    </el-select>
                    <el-select v-if="modelList.length > 0" filterable clearable @change="choseModel" v-model="searchForm.modelId" placeholder="型号" style="width:125px;margin-bottom:10px;margin-right: 10px">
                        <el-option 
                            v-for="item,index in modelList" 
                            :key="index" 
                            :label="item.modelName" 
                            :value="item.modelId">
                        </el-option>
                    </el-select>
                    <el-input clearable class="text-input" v-model.trim="searchForm.faultSubclassName" placeholder="请输入故障" style="margin-bottom: 10px;"></el-input>
                    <el-select filterable clearable v-model.trim="searchForm.serviceType" placeholder="订单类型" style="width:125px;margin-bottom:10px;margin-right: 10px">
                        <el-option 
                            v-for="item,index in orderTypeList" 
                            :key="index" 
                            :label="item.paraName" 
                            :value="item.paraValue">
                        </el-option>
                    </el-select>
                    <el-select filterable clearable v-model="searchForm.adminStatus" placeholder="订单状态" style="width:125px;margin-bottom:10px;margin-right: 10px">
                        <el-option v-for="item,index in orderStatusList" 
                            :key="index" 
                            :label="item.paraName" 
                            :value="item.paraValue">
                        </el-option>
                    </el-select>
                    <el-date-picker
                        style="width: 245px;margin-bottom:10px"
                        v-model="valueTime3"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        type="daterange"
                        range-separator="-"
                        :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="完成开始"
                        end-placeholder="完成结束">
                    </el-date-picker>
                    <el-select filterable clearable v-model="searchForm.orderIdentifier" placeholder="渠道" style="width:125px;margin-right: 10px">
                        <el-option v-for="item,index in OrderNolList" 
                            :key="index" 
                            :label="item.paraName" 
                            :value="item.paraValue">
                        </el-option>
                    </el-select>
                    <el-select filterable clearable v-model="searchForm.handleStatus" placeholder="处理状态" style="width:110px;margin-bottom: 10px;margin-right: 10px">
                        <el-option v-for="item,index in handleStatusList" 
                            :key="index" 
                            :label="item.paraName" 
                            :value="item.paraValue">
                        </el-option>
                    </el-select>
                    <div class="search-button-content">
                        <el-button type="primary" size="small" @click="onSubmit">检索工单</el-button>
                        <el-button type="success" size="small" v-if="basicsAuth.exportData" @click="downLoad.exportExcel('tableId')">导出</el-button>
                        <el-button type="text" @click="clearFrom">重置</el-button>
                    </div>
                </div>                
            </el-form>
        </el-col>
        <el-card class="box-card" style="width: 100%;">
            <el-table
                :data="returnData"
                border
                id="tableId"
                @row-dblclick="toDetail"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
                <el-table-column
                    align="center"
                    width="50" >
                    <template slot-scope="scope">  
                        <i class="el-icon-star-on" v-if="scope.row.isTag == 1" style="color:#f4ea2a;" @click="setOrderTagOpe(scope.row , 0)"></i>
                        <i class="el-icon-star-off"  @click="setOrderTagOpe(scope.row , 1)"  v-else></i>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    width="120"
                    sortable
                    label="工单状态">
                    <template  slot-scope="scope">
                        <span>{{scope.row.adminStatus|sysCodeFileter('admin_status')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="orderNo"
                    label="工单编号"
                    width="220" >
                    <template slot-scope="scope">
                        <span>{{scope.row.orderNo}}</span>
                        <!-- <el-button @click="toDetail(scope.row)" type="text">{{scope.row.orderNo}}</el-button> -->
                        <!-- <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(scope.row.orderNo,$event)"></i> -->
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    width="200"
                    :key="Math.random()"
                    v-if="activeIndex == 4"
                    prop="cannotConfirmDesc"
                    label="无法确认原因">
                </el-table-column>
                <el-table-column
                    align="center"
                    width="160"
                    prop="createTime"
                    sortable
                    label="下单时间">
                </el-table-column>
                <el-table-column
                    align="center"
                    width="120"
                    prop="customerName"
                    label="客户信息">
                    <template slot-scope="scope">
                        <!-- <span style="color:#409EFF">{{scope.row.customerName}}</span> -->
                        <el-button @click="toDetail(scope.row)" type="text">{{scope.row.customerName}}</el-button>
                        <i class="iconfont hohofast-copy copyBtn" @click="handleCopyCustomer(scope.row,$event)"></i>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    width="120"
                    prop="modelName"
                    sortable
                    label="型号">
                </el-table-column>
                <el-table-column
                    align="center"
                    width="80"
                    prop="colorName"
                    label="颜色">
                </el-table-column>
                <el-table-column 
                    sortable 
                    align="center" 
                    width="140" 
                    label="故障">
                    <template slot-scope="scope">
                        <span v-for=" (item,index) in scope.row.faultSubclass" :key="index" v-if="item != null && item.faultSubclassShortName != null" style="display:block">{{item.faultSubclassShortName}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    width="190"
                    sortable
                    label="预约时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.onsiteDate}} {{scope.row.onsiteTimeStart}}~{{scope.row.onsiteTimeEnd}} </span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="countyAddress"
                    sortable
                    width="120"
                    label="区域">
                </el-table-column>
                <el-table-column
                    align="left"
                    prop="address"
                    width="330"
                    label="地址">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="orderIdentifier"
                    width="110"
                    sortable
                    label="渠道">
                    <template slot-scope="scope">
                        {{scope.row.orderIdentifier | sysCodeFileter('order_identifier')}}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    width="120"
                    sortable
                    label="工单类型">
                    <template slot-scope="scope">
                        <span>{{scope.row.serviceType|sysCodeFileter('order_type')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    sortable
                    width="100"
                    prop="staffName"
                    label="受理人">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="handleName"
                    width="100"
                    sortable
                    label="处理人">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="handleDate"
                    width="160"
                    sortable
                    label="处理时间">
                    <template slot-scope="scope">
                        <span v-if="scope.row.handleDate">{{scope.row.handleDate | date}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="cancelReason"
                    width="200"
                    sortable
                    label="取消原因">
                    <template slot-scope="scope">
                        {{scope.row.cancelReason | sysCodeFileter('order_cancel_reason')}}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="cancelDesc"
                    width="200"
                    label="原因描述">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="maintenanceResult"
                    width="150"
                    sortable
                    label="维修结果">
                    <template slot-scope="scope">
                        {{scope.row.maintenanceResult | sysCodeFileter('maintenance_result')}}
                    </template>
                </el-table-column>
                 <el-table-column
                    align="center"
                    prop="actualPrice"
                    width="120"
                    sortable
                    label="实收金额">
                </el-table-column>
                <el-table-column
                    align="center"
                    width="190"
                    fixed="right"
                    :key="Math.random()"
                    v-if="activeIndex === 6"
                    label="送机方式">
                    <template slot-scope="scope" v-if="activeIndex === 6"> 
                        <el-form :inline="true" class="wayId">
                            <el-form-item>
                                <el-select filterable v-model="scope.row.sendMachineWay" filterable placeholder="送机方式">
                                    <el-option v-for="(item,index) in sendWaylList" 
                                        :label="item.paraName" 
                                        :value="item.paraValue" 
                                        :key="index">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button v-if="basicsAuth.sendWays" @click="confirmSendWay(scope.row)" type="text">确认</el-button>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    fixed="right"
                    width="60"
                    label="履历">
                    <template slot-scope="scope">
                        <el-button @click="checkHitoryRecord(scope.row.id)" type="text">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog title="订单修改记录" :visible.sync="dialogTableVisible">
                <el-table :data="historyList" border>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.orderNo" 
                        label="服务单号" 
                        width="180">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.createTime" 
                        label="下单时间" 
                        width="180">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.updateTime" 
                        label="修改时间" 
                        width="180">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.updateUserName" 
                        label="修改人" 
                        width="100">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.orderType" 
                        label="工单类型" 
                        width="100">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.adminStatus" 
                        label="状态" 
                        width="100">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.orderIdentifier" 
                        label="渠道来源" 
                        width="100">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.customerName" 
                        label="客户姓名" 
                        width="100">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.telephoneNo" 
                        label="手机号码" 
                        width="120">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.provinceName" 
                        label="所在省" 
                        width="100">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.cityName" 
                        label="所在市" 
                        width="100">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.countyName" 
                        label="所在区" 
                        width="100">
                    </el-table-column>
                    <el-table-column 
                        align="left" 
                        prop="oldOrderInfo.address" 
                        label="详细地址" 
                        width="150">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.onsiteDate" 
                        label="预约日期" 
                        width="150">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        label="预约时间" 
                        width="150">
                        <template slot-scope="scope">
                            {{scope.row.oldOrderInfo.onsiteTimeStart}} ~ {{scope.row.oldOrderInfo.onsiteTimeEnd}}
                        </template>
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.brandName" 
                        label="品牌" 
                        width="120">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.categoryName" 
                        label="品类" 
                        width="120">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.modelName" 
                        label="型号" 
                        width="120">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.colorName" 
                        label="颜色" 
                        width="100">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.faultSubclassNames" 
                        label="问题代码" 
                        width="200">
                    </el-table-column>
                    <el-table-column 
                        align="center" 
                        prop="oldOrderInfo.price" 
                        label="维修估价(元)" 
                        width="150">
                    </el-table-column>
                </el-table>
            </el-dialog>
            <el-dialog title="支付" width="400px"  :visible.sync="dialogModelFormVisible" @close="emptyPayDialog">
                <el-form ref="modelPayForm" :rules="modelFormRules" :model="modelPayForm" label-width="100px" :label-position="labelPosition">
                    <el-form-item label="支付方式" prop="paymentId" clearable>
                        <el-select filterable v-model="modelPayForm.paymentId" placeholder="请选择支付方式">
                            <el-option v-for="(item,index) in payWaylList" 
                                :label="item.paraName" 
                                :value="item.paraValue" 
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="支付金额" prop="actualPrice">
                        <el-input v-model.trim="modelPayForm.actualPrice" placeholder="请输入实收金额" clearable auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="emptyPayDialog">取 消</el-button>
                    <el-button type="primary" @click="saveModelFormSubmitBtn('modelPayForm')">确 定</el-button>
                </div>
            </el-dialog>
            <!--分页-->
            <el-col :span="30" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100,500,1000]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-card>  
    </div>
</template>

<script>
    import {
        inventoryList,inventorySerial,selectParameterInfoBusiness,selectMaterialClassifications,engineerList,
        selectAllBrand,selectCategory,selectModel,queryUser,zhselectParameterInfoBusiness
    } from "../../api/api";

    import { querySysRegion , queryColor , selectfaultTypes , selectFaultSubclass} from '@/api/system'
    import {selectWorkOrder , selectTotalOrderQuantity , selectTotalOrderApplyRmk , getOrderTotal , setOrderTag,getHistoryList,maintenancePending,queryCustomerServices } from '@/api/order'
    import {getPermission} from '../../api/authRequest';
    import clip from '@/util/clipboard';
    import PinyinMatch from 'pinyin-match';
    export default {
        name: 'workOrderManageRmk',
        components: {},
        data () {
            const validateNumber = (rule, value, callback) => {
                if (!/^(0|\+?[1-9][0-9]*)$/.test(value)) {
                    callback(new Error("实收价格不能为空且为整数"));
                }else {
                    callback();
                }
            }
            return {
                valueTime1:[],
                valueTime2:[],
                valueTime3:[],
                activeIndex:1,
                defaultOrderStatus:'',
                labelPosition:'left',
                searchForm:{
                    orderNo:'',
                    userName:'',
                    userPhone:'',
                    userAddress:'',
                    handleUser:'',
                    orderTime1:'',
                    orderTime2:'',
                    appoTime1:'',
                    appoTime2:'',
                    brandId:'',
                    categoryId:'',
                    modelId:'',
                    faultSubclassName:'',
                    serviceType:'',
                    adminStatus:'',
                    createTimeStart:'',
                    createTimeEnd:'',
                    orderIdentifier:'',
                    onsiteTimeStarts:'',
                    onsiteTimeEnds:'',
                },
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                handleList:[],
                copy:[],
                engineersList:[],
                brandList:[],       //品牌数组
                categoryList:[],    //品类数组
                modelList:[],        //型号数组
                returnData:[],
                faultSubclassList:[],
                orderTypeList:[],
                orderStatusList:[],
                OrderNolList:[],
                handleStatusList:[],
                orderResult:{},
                orderCount:{
                    count1: 0 ,
                    count2: 0 ,
                    count3: 0 ,
                    count4: 0 ,
                    count5: 0 ,
                    count6: 0 ,
                    count11 : 0
                },
                isTagNow:false,
                dialogTableVisible:false,
                historyList:[],
                sendWaylList:[],
                payWaylList:[],
                dialogModelFormVisible:false,
                modelPayForm:{
                    id:'',
                    actualPrice:'',
                    paymentId:'',
                },
                modelFormRules:{
                    paymentId: [{ required: true, message: "请选择支付方式", trigger: "blur" }],
                    actualPrice: [{ required: true, validator: validateNumber, trigger: 'blur' }],
                },
                basicsAuth:{
                    createOrder:false,
                    getOrderDetails:false,
                    sendWays:false
                }
            }
        },
        created(){
            //this.clickLi(this.activeIndex);   //默认查看待处理订单
            // this.getHandleList();
            // this.getEngineerList();
            // this.getBrandList();
            // this.getAllOrderType();
            // this.getAllOrderStatus();
            // this.getOrderNol();
            // this.selectTotalOrderQuantityOpe();
            // this.getSendWays();
            // this.getPayWays();
            
        },
        activated(){
            this.returnData = [];
            this.clickLi(this.activeIndex);   //默认查看待处理订单
            this.getHandleList();
            this.getEngineerList();
            this.getBrandList();
            this.getAllOrderType();
            this.getAllOrderStatus();
            this.getOrderNol();
            this.getHandleStatusList();
            this.getHandleStatusList();
            this.selectTotalOrderQuantityOpe();
            this.getSendWays();
            this.getPayWays();
        },
        mounted () {
            this.basicsAuth.createOrder = getPermission('/api/workOrder/order/createOrder');
            this.basicsAuth.getOrderDetails = getPermission('/api/workOrder/order/getOrderDetails');
            this.basicsAuth.sendWays = getPermission('/api/workOrder/order/maintenance_pending');
            this.basicsAuth.exportData = getPermission('/api/export/data');
        },
        methods: {
            //强制刷新
            changeEnginner(e){
                console.log(e);
                this.searchForm.engineerId = e;
                this.$forceUpdate();
            },
            //工程师拼音模糊搜索
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.engineerId = val;
                    this.engineersList = result;
                }else{
                    this.engineersList = this.copy;
                    this.searchForm.engineerId = "";
                }
            },
            //支付弹出框
            payDialog(row){
                this.modelPayForm.id = row.id;
                this.modelPayForm.sendMachineWay = row.sendMachineWay;
                this.dialogModelFormVisible = true;
            },
            //支付弹出框关闭
            emptyPayDialog(){
                this.dialogModelFormVisible = false;
                this.modelPayForm = {};
                this.$refs['modelPayForm'].resetFields();
            },
            //提交支付
            saveModelFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        maintenancePending(this.modelPayForm).then(res =>{
                            if(res.data.status == '100'){
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.emptyPayDialog();
                                /*刷新*/
                                this.refresh();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch(error =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //查询支付方式
            getPayWays(){
                let param = {
                    paraType : 'pay_way'
                }
                selectParameterInfoBusiness(param).then(res =>{
                    if(res.data.status == '100'){
                        this.payWaylList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch(error =>{
                    this.$Message.error(error.message);
                })
            },
            //确认送机方式
            confirmSendWay(row){
                if(!row.sendMachineWay){
                    this.$message({
                        message: '请选择送机方式',
                        type: "warning"
                    });
                    return;
                }
                if(row.sendMachineWay == 2){
                    this.payDialog(row);
                    return;
                }
                let param = {
                    id : row.id,
                    sendMachineWay:row.sendMachineWay
                }
                maintenancePending(param).then(res =>{
                    if(res.data.status == '100'){
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        this.refresh();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch(error =>{
                    this.$Message.error(error.message);
                })
            },
            //查询送机方式
            getSendWays(){
                let param = {
                    paraType : 'send_machine_way'
                }
                selectParameterInfoBusiness(param).then(res =>{
                    if(res.data.status == '100'){
                        this.sendWaylList = res.data.results.list;
                        this.sendWaylList.forEach((item,index)=>{
                            item.paraValue = Number(item.paraValue)
                        })
                        console.log(this.sendWaylList)
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch(error =>{
                    this.$Message.error(error.message);
                })
            },
            //复制订单号
            handleCopy(text, event) {
                clip(text, event)
            },
            handleCopyCustomer(row, event) {
                let faultSubclassStr = "";
                let modelName = row.modelName;
                if(row.faultSubclass){
                    row.faultSubclass.forEach((item,index)=>{
                        if(index < (row.faultSubclass.length - 1)){
                            faultSubclassStr += item.faultSubclassShortName+'、';
                        }else{
                            faultSubclassStr += item.faultSubclassShortName+'  ';
                        }
                    })
                }
                if(modelName){
                    if(modelName.indexOf(' ') != -1){
                        modelName = modelName.replace(/\s*/g,"");
                    }
                }
                let text = modelName+'  '+row.colorName+'  '+faultSubclassStr+row.onsiteDate+'  '+row.onsiteTimeEnd+'  '+row.countyName+row.address;
                clip(text, event);
            },
            //查看详情
            toDetail(row,columns,event){
                sessionStorage.setItem('orderType', 1);
                this.$router.push({
                    path:"/visitRepair",
                    query:{
                        orderId:row.id,
                        orderNo:row.orderNo
                    }
                })
            },
            checkHitoryRecord(id){
                this.dialogTableVisible = true;
                this.getHistoryList(id);
            },
             //查询订单历史修改记录
            getHistoryList(id){
                let param = {
                    id : id
                }
                getHistoryList(param).then(res =>{
                    if(res.data.status == '100'){
                        this.historyList = res.data.results
                    }
                }).catch(error =>{
                    this.$Message.error(error.message);
                })
            },
            //查询订单渠道
            getOrderNol(){
                let param = {
                    paraType : 'order_identifier',
                    startRow:1,
                    pageSize:1000
                }
                zhselectParameterInfoBusiness(param).then(res =>{
                    if(res.data.status == '100'){
                        this.OrderNolList = res.data.results.list
                    }
                }).catch(error =>{
                    this.$Message.error(error.message);
                })
            },
            //查询处理状态
            getHandleStatusList(){
                let param = {
                    paraType : 'handle_status',
                    startRow:1,
                    pageSize:10000
                }
                selectParameterInfoBusiness(param).then(res =>{
                    if(res.data.status == '100'){
                        this.handleStatusList = res.data.results.list
                    }
                }).catch(error =>{
                    this.$Message.error(error.message);
                })
            },
            //标记
            setOrderTagOpe(order , tag){
                if(this.isTagNow){
                    this.$message({
                        message: '正在处理请稍后！',
                        type: 'error'
                    })
                    return
                }
                this.isTagNow = true
                let param = {
                    orderId : order.id,
                    tag : tag
                }
                setOrderTag(param).then(res =>{
                    if(res.data.status==100){
                        this.isTagNow = false
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.onSubmit();
                    }else{
                        this.isTagNow = false
                        this.$message({
                            message: '操作失败',
                            type: 'error'
                        });
                    }
                    this.isTagNow = false
                })
            },
            //点击查询订单列表
            clickLi(index){
                this.activeIndex = index
                if(index == 0 ){
                    this.searchForm.adminStatus = null
                }
                if(index == 1 ){
                    this.searchForm.adminStatus = "01"
                }
                if(index == 2){
                    this.searchForm.adminStatus = "04"  
                }
                if(index == 11){
                    this.searchForm.adminStatus = '14'
                }
                if(index == 3){
                    this.searchForm.adminStatus = null
                    this.searchForm.adminStatusList = ['03', '05'  , '06' ,'07' , '08' , '09'  , '13' , '14' ]
                }
                if(index == 4){
                    this.searchForm.adminStatus = "02"
                }
                if(index == 5){
                    this.searchForm.adminStatus = "20"
                }
                if(index == 6){
                    this.searchForm.adminStatus = null
                    this.searchForm.adminStatusList = ["36"]
                }
                
                if(index != 6 && index != 3){
                    this.searchForm.adminStatusList = null
                }
                this.searchForm.startRow = 1; //请求第一页数据
                this.onSubmit();
            },
            //查询客服主管工单页面有多少状态数量
            selectTotalOrderQuantityOpe(){
                this.orderCount.count3 = 0;
                this.orderCount.count6 = 0;
                this.orderCount.count1 = 0;
                this.orderCount.count2 = 0;
                this.orderCount.count4 = 0;
                this.orderCount.count5 = 0;
                this.orderCount.count11 = 0;
                selectTotalOrderApplyRmk().then(res =>{
                    if(res.data.status == '100'){
                        let array = res.data.results
                        for(let i = 0 ;i< array.length ; i++ ){
                            if(array[i].adminStatus == '01'){
                                this.orderCount.count1 = array[i].adminCount
                            }
                            if(array[i].adminStatus == '04'){
                                this.orderCount.count2 = array[i].adminCount
                            }
                            if(array[i].adminStatus == '03' || array[i].adminStatus == '05' ||  array[i].adminStatus == '06' || array[i].adminStatus == '07' || array[i].adminStatus == '08' || array[i].adminStatus == '09'  || array[i].adminStatus == '13' || array[i].adminStatus == '14'){
                                this.orderCount.count3 += array[i].adminCount
                            }
                            if(array[i].adminStatus == '02'){
                                this.orderCount.count4 = array[i].adminCount
                            }
                            if(array[i].adminStatus == '20'){
                                this.orderCount.count5 = array[i].adminCount
                            }
                            //维修后待处理
                            if(array[i].adminStatus == '36' ){
                                this.orderCount.count6 = array[i].adminCount
                            }

                            if(array[i].adminStatus == '14' ){
                                this.orderCount.count11 = array[i].adminCount
                            }
                        }
                    }
                })
            },
            //新建工单
            createOrder() {
                sessionStorage.setItem('orderTypeNew', 1);
                this.$router.push({
                    path:'/newWorkOrder',
                    query:{
                        isExcludeJhh : 0
                    }
                })
            },
            //获取故障小类数据
            selectFaultSubclassOpe(){
                let query = {
                    modelId :this.searchForm.modelId 
                }
                selectFaultSubclass(query).then(res =>{
                    if(res.data.status == '100'){
                        this.faultSubclassList = res.data.results
                    }
                }).catch(error =>{
                    this.$Message.error(error.message);
                })
            },
            //选择品牌
            choseBrand(){
                this.modelList = [];
                this.getCategoryList();
                this.searchForm.categoryId = "";
                this.searchForm.modelId = "";
            },
            //选择品类
            choseCategory(){
                this.searchForm.modelId = "";
                this.getModelList();
            },
            //选择型号
            choseModel(){
            },
            //机型型号
            getModelList(){
                let para={
                    brandId:this.searchForm.brandId,
                    categoryId:this.searchForm.categoryId
                };
                selectModel(para).then(res => {
                    if (res.data.status==100) {
                        this.modelList = res.data.results;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //机型品类
            getCategoryList(){
                let para={
                    brandId:this.searchForm.brandId
                };
                selectCategory(para).then(res => {
                    if (res.data.status==100) {
                        this.categoryList = res.data.results;            
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
             //刷新
            refresh() {
                this.searchForm.startRow = 1; //请求第一页数据
                this.pages.page = 1;
                this.onSubmit();
                this.selectTotalOrderQuantityOpe();
            },
            onSubmit() {
                let year="",month = "",date="";
                if(this.valueTime1 != null && this.valueTime1.length > 1 ){
                    this.searchForm.createTimeStart = new Date(this.valueTime1[0])
                    this.searchForm.createTimeEnd = new Date(this.valueTime1[1])
                }else{
                    this.searchForm.createTimeStart = "";
                    this.searchForm.createTimeEnd = "";
                }
                if(this.valueTime2 != null && this.valueTime2.length > 1 ){
                    this.searchForm.onsiteTimeStarts = new Date(this.valueTime2[0])
                    this.searchForm.onsiteTimeEnds = new Date(this.valueTime2[1])
                }else{
                    this.searchForm.onsiteTimeStarts = "";
                    this.searchForm.onsiteTimeEnds = "";
                }
                if(this.valueTime3 != null && this.valueTime3.length > 1 ){
                    this.searchForm.handleDateStarts = new Date(this.valueTime3[0]);
                    this.searchForm.handleDateEnds = new Date(this.valueTime3[1]);
                }else{
                    this.searchForm.handleDateStarts = "";
                    this.searchForm.handleDateEnds = "";
                }
                this.searchForm.accountType = (this.activeIndex == 0) ? 1 : 2;
                selectWorkOrder( this.searchForm).then(res =>{
                    if(res.data.status == '100'){
                        this.pages.total = res.data.results.total;
                        res.data.results.list.forEach((item,index)=>{
                            item.sendMachineWay = (item.sendMachineWay === 0) ? "" : item.sendMachineWay;
                            item.staffName = item.staffName == null ? "" : item.staffName;
                            item.handleDate = item.handleDate == null ? "" :item.handleDate;
                            item.modelName = !item.modelName ? "" : item.modelName;
                            item.createTime = this.filters.formatDate(item.createTime);
                            if(item.serviceType == 'DD' || item.serviceType == 'DS'){
                                item.countyAddress = !item.shopName ? '' : item.shopName;
                            }else{
                                item.countyAddress = !item.countyName ? '' : item.countyName;
                            }
                        });
                        this.returnData = res.data.results.list;
                        this.$forceUpdate();
                    }else {
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }       
                })
            },
            //重置
            clearFrom(){
                this.valueTime1 = [];
                this.valueTime2 = [];
                this.valueTime3 = [];
                this.searchForm.orderNo = "";
                this.searchForm.customerName = "";
                this.searchForm.telephoneNo = "";
                this.searchForm.address = "";
                this.searchForm.staffName = "";
                this.searchForm.brandId = "";
                this.searchForm.categoryId = "";
                this.searchForm.modelId = "";
                this.searchForm.serviceType = "";
                this.searchForm.orderIdentifier = "";
                this.searchForm.engineerId = "";
                this.searchForm.faultSubclassName = "";
                this.refresh();
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.searchForm.pageSize = val
                this.onSubmit()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.searchForm.startRow = Page
                this.onSubmit()
            },
            //获取处理人
            getHandleList(){
                let param = {
                    type : 2
                }
                queryUser(param).then(res =>{
                    if(res.data.status == '100'){
                        this.handleList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch(error =>{
                    this.$Message.error(error.message);
                })
            },
            //获取工程师
            getEngineerList(){
                let params = {
                    startRow:1,
                    pageSize:10000,
                    state:1
                }
                engineerList(params).then(res => {
                    if (res.data.status==100) {
                        this.engineersList = res.data.results.list;
                        this.copy = Object.assign(this.engineersList); //保留源数据
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取品牌
            getBrandList(){
                selectAllBrand().then(res => {
                    if (res.data.status==100) {
                        this.brandList = res.data.results;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取订单类型
            getAllOrderType(){
                selectParameterInfoBusiness({
                    'startRows' : 1,
                    'pageSize' : 100,
                    'paraType' :'order_type' 
                }).then(resp => {
                    if(resp.data.results){
                        this.orderTypeList = resp.data.results.list
                    }
                })
            },
            //获取订单状态
            getAllOrderStatus(){
                selectParameterInfoBusiness({
                  'startRows' : 1,
                  'pageSize' : 100,
                  'paraType' :'admin_status' 
                }).then(resp => {
                    if(resp.data.results){
                        this.orderStatusList = resp.data.results.list
                    }
                })
            }
        }
    }
</script>

<style lang="scss" type="text/css" scoped>
    #workOrderManageRmk{
        font-size: 14px;
        .copyBtn{
            font-size: 17px;
            cursor: pointer;
            display:block;
            float: right;
            margin-top:10px;
        }
        .wayId{
            .el-input{
                width: 110px;
                input{
                    width: 110px !important;
                }
            }
        }
        .headerT{
            margin:8px 0 15px 0;
            width: 80px;
            display: inline-block;
        }
        .search-button-content{
            margin-left:10px;
            .el-button{
                height:auto !important
            }
        }
        .el-input{
            width: 100%;
            input{
                width: 161px;
            }
        }
        .guzhang{
            .el-input{
                input{
                    width: 240px;
                }
            }   
        }
        .orderListsLi{
            border:1px solid #c6c6c6;
            border-radius: 5px;
            margin-bottom: 10px;
            line-height: 35px;
            cursor: pointer;
            text-align: center;
        }
        .orderListsLi.highLight{
            background-color: #1abc9c;
            border-color: #fff;
            color: #fff;
        }
    }
    .searthPart{
        .order-status{
            display: flex;
            li{
                width:161px;
                margin-left: 10px;
            }
            li:nth-child(1){
                margin-left: 0
            }
        }
        .form-wrapper{
            margin-bottom: 20px
        }
        .form-content{
            display: flex;
            display: flex;
            display: -webkit-flex;
            flex-wrap: wrap;
            .el-input--suffix .el-input__inner{
                padding-right:0!important;
            }
            .text-input{
                width:161px !important;
                padding-right:0;
                span{
                    top: 10px;
                }
            }

            .el-input,.el-date-editor{
                margin-right: 10px;
                width: 161px;
                .el-input__prefix, .el-input__suffix{
                    height: auto !important
                }
                .el-input__icon{
                    height: auto !important
                }
            }
            .el-button{
                height: 40px;
            }
            .el-input__icon{
                height: 40px !important
            }
        }
    }
    .toolbar{
        .el-pagination .el-input__suffix{
            right: 8px!important;
        }
    }
    
  
</style>
<style lang="scss">
    #workOrderManageRmk{
        .wayId{
            .el-input{
                width: 110px !important;
                input{
                    width: 110px !important;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// workOrderManageRmk.vue?1e3116d2